import { useTranslation } from 'react-i18next'

import InputAutocomplete from './AutocompleteBasic'

export default function Levels(props) {
    const [t] = useTranslation('common', { keyPrefix: 'levels' })

    const setLevelEnum = (value) => {
        switch (value) {
            case 1:
                return t('levelEasy')
            case 2:
                return t('levelMedium')
            case 3:
                return t('levelDifficult')
            default:
                console.log('Error: level value not valid')
                break
        }
    }

    return (
        <InputAutocomplete
            defaultValue={props.defaultValue}
            loading={false}
            optionlabel={(option) => setLevelEnum(option)}
            required={true}
            multiple={false}
            setErrorRequired={props.setError}
            list_names={props.list}
            freeSolo={false}
            setValue={props.setValue}
            error_required={props.error}
            t={t}
        />
    )
}
